import { debug } from '../../../utils/debug.ts';
import { type IExpression } from '../IExpression.ts';
import { evaluateExpression } from './evaluateExpression.ts';
import { type IMaterializedReference } from './materializeReferencePath.ts';
import { type IEvaluationVariables } from './variables/IEvaluationVariables.ts';

/**
 * Forniti i dati di un'espressione, restituisce il valore calcolato.
 */
export function getExpressionValue(input: {
  name: string;
  expression: IExpression | null | undefined;
  references: IMaterializedReference[];
  variables: IEvaluationVariables;
}) {
  const { name, expression, variables } = input;
  if (!expression) return { type: 'null' as const };

  // biome-ignore format: <tbd>
  debug.log(`expression.evaluate.get`, 'getExpressionValue params:', { name, expression, variables });

  const result = evaluateExpression(expression, {
    variables,
  });
  // biome-ignore format: <tbd>
  debug.log(`expression.evaluate.get`, 'getExpressionValue result:', { result, variables });
  return { type: 'value' as const, result };
}

/**
 * Funzione utilizzata quando dobbiamo assumere che un valore `null` è true,
 * casi di esempio:
 * - `visible: null` -> visibile
 * - regola condizionale su RTE null -> visibile
 */
export function isExpressionValueActive(
  expressionValue: ReturnType<typeof getExpressionValue>,
) {
  return !(
    expressionValue.type === 'value' && expressionValue.result === false
  );
}
